import type { ProjectState } from '../project-slice-reducer';

interface WithProjectState {
  project: ProjectState;
}

/**
 * @description
 * Selector to get the project id from the project-slice state in `packages/redux-state`.
 * @returns The project id.
 * @example
 * ```ts
 * import { useSelector } from 'react-redux';
 * import { projectSliceSelectors } from '@highlight-cp/redux-state';
 *
 * const projectId = useSelector(projectSliceSelectors.id);
 * ```
 */
export const id = (state: WithProjectState) => state.project.id;
